module.exports = __webpack_public_path__ + "static/img/区域宏观运行指标概览.e939ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/区域宏观运行指标概览.jpg
// module id = Uj71
// module chunks = 1